/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keyword_Optimizer_Generate_Cta_ButtonInputs */

const en_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate AI Rewording →`)
};

const de_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Umformulierung generieren →`)
};

const fr_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer la reformulation IA →`)
};

const es_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generar reformulación con IA →`)
};

const it_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genera riformulazione IA →`)
};

const nl_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-herformulering genereren →`)
};

const pl_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wygeneruj przeredagowanie AI →`)
};

const fi_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo AI-uudelleenmuotoilu →`)
};

const da_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generer AI-omformulering →`)
};

const sv_keyword_optimizer_generate_cta_button = /** @type {(inputs: Keyword_Optimizer_Generate_Cta_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generera AI-omformulering →`)
};

/**
* | output |
* | --- |
* | "Generate AI Rewording →" |
*
* @param {Keyword_Optimizer_Generate_Cta_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const keyword_optimizer_generate_cta_button = /** @type {((inputs?: Keyword_Optimizer_Generate_Cta_ButtonInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keyword_Optimizer_Generate_Cta_ButtonInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_keyword_optimizer_generate_cta_button(inputs)
	if (locale === "fr") return fr_keyword_optimizer_generate_cta_button(inputs)
	if (locale === "es") return es_keyword_optimizer_generate_cta_button(inputs)
	if (locale === "it") return it_keyword_optimizer_generate_cta_button(inputs)
	if (locale === "nl") return nl_keyword_optimizer_generate_cta_button(inputs)
	if (locale === "pl") return pl_keyword_optimizer_generate_cta_button(inputs)
	if (locale === "fi") return fi_keyword_optimizer_generate_cta_button(inputs)
	if (locale === "da") return da_keyword_optimizer_generate_cta_button(inputs)
	if (locale === "sv") return sv_keyword_optimizer_generate_cta_button(inputs)
	return en_keyword_optimizer_generate_cta_button(inputs)
});